<template>
    <div>

        <main v-if="skolskaUloha" class="kvizove-ulohy">

            <article v-show="step === 'uvod'" class="d-grid position-relative uvod-height">
                <img src="assets/img/uvod-kviz.jpg" alt="" class="uvodny-obr">
                <div v-if="skolskaUloha" class="position-absolute">
                    <span class="badge-pill --success mb-30">{{ skolskaUloha.nazov }}</span>
                    <h2 class="mb-30">{{ skolskaUloha.podnadpis }}</h2>
                    <p class="mb-50">{{ skolskaUloha.zadanie }}</p>
                    <button class="btn --primary btn-lg" @click="startQuiz">spustiť kvíz<span class="icon --arrow-right"></span></button>
                    <p v-if="errorMessage" class="text-danger mt-1">{{ errorMessage }}</p>
                </div>
            </article>

            <article v-show="step === 'kviz'" class="d-grid position-relative bg-white without-img">
                <div class="count">
                    <span class="actual">{{ currentQuestion }}</span>
                    <span class="separator">/</span>
                    <span class="total">{{ skolskaUloha.pocet_otazok }}</span>
                </div>
                <div class="time">
                    <span class="icon icon--stopwatch"></span><span>{{ timer }}</span>
                </div>

                <template v-for="(otazka, index) in skolskaUloha.otazky">
                    <skoly-ulohy-kvizova-otazka
                            v-if="(index+1) === currentQuestion"
                            :otazka="otazka"
                            :key="index"
                            @next="next"
                    />
                </template>
            </article>

            <article v-show="step === 'vyhodnotenie'" class="d-grid position-relative bg-white full-h">
                <img src="assets/img/vyhodnotenie-bg.jpg" alt="" class="img-fluid">
                <div class="position-absolute">
                    <template v-if="!errorMessage">
                        <img src="assets/img/success-badge.svg" alt="" class="img-fluid mb-20">
                        <h2 class="mb-10">Výborne, zvládli ste to!</h2>
                        <p class="mb-30">Kravička je na vás pyšná.</p>
                    </template>
                    <template v-else>
                        <img src="assets/img/error-badge.svg" alt="" class="img-fluid mb-20">
                        <h2 class="mb-10">{{ errorMessage }}</h2>
                        <p class="mb-30">Do súťaže nezískavate ani jeden bod</p>
                    </template>

                    <aside class="d-flex kviz-vysledok">
                        <div class="time">
                            <span class="icon icon--stopwatch"></span><span>{{ kvizDuration }}</span>
                        </div>
                        <div class="status">
                            <span class="icon icon--question-mark"></span>
                            <div class="count">
                                <span class="actual">{{ spravneOdpovede }}</span>
                                <span class="separator">/</span>
                                <span class="total">{{ skolskaUloha.pocet_otazok }}</span>
                            </div>
                            <ul class="ulohy">
                                <li v-for="(value, index) in spravnostOdpovedi" :class="{'done': value, 'wrong': !value }" :key="index">{{ index+1 }}</li>
                            </ul>
                        </div>
                    </aside>
                    <router-link v-if="profil.pouzivatel_id" :to="{ name: 'skoly-ulohy', params: { 'rocnik': profil.pouzivatel_id.pouzivatel_rocnik } }" class="btn --primary">spať na zoznam úloh<span class="icon --bars"></span></router-link>
                </div>
            </article>

            <router-link v-if="profil.pouzivatel_id && step !== 'kviz'" :to="{ name: 'skoly-ulohy', params: { 'rocnik': profil.pouzivatel_id.pouzivatel_rocnik } }" class="btn --secondary --circle close-btn">
                <span class="icon --close"></span>
            </router-link>

        </main>

    </div>
</template>

<script>
import EventService from '@/services/EventService.js'
import HeaderProfil from '../partials/HeaderProfil.vue'
import MenuProfil   from '../partials/MenuProfil.vue'
import BError from "@/components/b-error.vue";
import SkolyUlohyKvizovaOtazka from "@/components/skoly/SkolyUlohyKvizovaOtazka.vue";

export default {
    components: {
        SkolyUlohyKvizovaOtazka,
        BError,
        HeaderProfil,
        MenuProfil
    },
    props: [
        'profil',
        'spravy',
    ],
    data() {
        return {
            skolskaUloha: null,
            step: 'uvod',
            vypracovanie: {
                odpovede: [],
                body: 0,
                bonusove_body: 0,
            },
            error: {},
            currentQuestion: 1,
            isLoading: false,
            kvizStart: {},
            kvizStop: {},
            timer: '00:00',
            kvizDuration: '00:00',
            spravneOdpovede: 0,
            spravnostOdpovedi: [],
            errorMessage: '',
        }
    },
    mounted() {
        this.getSkolskaUloha()

        if (typeof(this.profil.pouzivatel_id) == "undefined" || this.profil.id == 0) {
            this.$emit('updateProfil')
        }
    },
    methods: {
        // emit
        emitUpdateProfil() {
            this.$emit('updateProfil')
        },

        async getSkolskaUloha() {
            let { data } = await EventService.getSkolskaUloha(this.$route.params.uloha_id)
            this.skolskaUloha = data.data
        },

        async startQuiz() {
            this.isLoading = true
            try {
                let { data } = await EventService.startKviz( this.skolskaUloha.id )
                this.kvizStart = data
                this.step = 'kviz'
                this.countDownTimer()
            } catch (e) {
                if ( e.response && e.response.data && e.response.data.message ) {
                    this.errorMessage = e.response.data.message
                } else {
                    this.errorMessage = e.message
                }

            } finally {
                this.isLoading = false
            }
        },

        countDownTimer() {
            let now = new Date();
            let deadline = new Date(this.kvizStart.kviz_deadline);

            let timeDiff = deadline - now;

            if( timeDiff >= 0 ) {
                setTimeout(() => {
                    this.timer =  this.formatTimeDiff(timeDiff)
                    this.countDownTimer()
                }, 1000)
            }
        },


        getKvizDuration() {
            let end = new Date(this.kvizStop.kviz_stop);
            let start = new Date(this.kvizStop.kviz_start);

            let timeDiff = end - start;
            this.kvizDuration = this.formatTimeDiff(timeDiff)
        },

        formatTimeDiff(timeDiff) {
            let minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
            let seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

            let minutesString = ( minutes.toString().length === 1 ) ? '0' + minutes: minutes
            let secondsString = ( seconds.toString().length === 1 ) ? '0' + seconds: seconds

            return minutesString + ':' + secondsString
        },

        async next(odpoved) {
            this.vypracovanie.odpovede.push( odpoved.input )
            if ( this.currentQuestion === this.skolskaUloha.otazky.length ) {
                this.countBody()

                try {
                    let { data } = await EventService.stopKviz( this.kvizStart.id, this.vypracovanie )
                    this.emitUpdateProfil()
                    this.kvizStop = data
                    this.getKvizDuration()
                } catch (e) {
                    if ( e.response && e.response.data && e.response.data.message ) {
                        this.errorMessage = e.response.data.message
                    }
                } finally {
                    this.step = 'vyhodnotenie'
                }
            } else {
                this.currentQuestion++
            }
        },

        countBody() {
            for ( let index in this.skolskaUloha.otazky ) {
                if ( this.skolskaUloha.otazky[index].otazka_typ === 'radio' ) {
                    if ( this.skolskaUloha.otazky[index].spravna_odpoved === this.vypracovanie.odpovede[index] ) {
                        this.spravneOdpovede++
                        this.spravnostOdpovedi.push(true)
                    } else {
                        this.spravnostOdpovedi.push(false)
                    }
                } else {
                    if ( this.skolskaUloha.otazky[index].textove_varianty.includes( this.vypracovanie.odpovede[index] ) ) {
                        this.spravneOdpovede++
                        this.spravnostOdpovedi.push(true)
                    } else {
                        this.spravnostOdpovedi.push(false)
                    }
                }
            }

            this.vypracovanie.body = this.skolskaUloha.pocet_bodov * this.spravneOdpovede / this.skolskaUloha.pocet_otazok
        },
    }
}
</script>
